import React from 'react';

export const GetCareerModule = (props) => {

    return(
        <div className="four-getcareer">
            <div className="four-right-top">
                <img src={require('../../../assets/images/fiveModule/yzy/top-banner.png')} alt="选考在线"/>
            </div>
            <div className="four-getcareer-main">
                <div className='top'>
                    <div>
                        <div style={{ marginBottom: 43 }}>
                        随着高考改革的深入，考生和家长对高质量志愿填报服务的需求日益增长，但传统的以考生和家长为主体的志愿填报方式往往存在信息不对称、缺乏专业指导等问题。壹志愿工作坊的出现，正是为了解决这些问题。
                        </div>
                        <div>
                        壹志愿工作坊是“选考在线”开发运营的高中生升学管理及高考志愿填报服务平台。平台专为从事高中生升学规划、高考志愿填报服务的机构和咨询师开发，是咨询师进行升学规划、志愿填报服务的工具和平台，也是机构开展相关业务活动的管理工具和平台。
                        </div>
                    </div>
                    <img src={require('../../../assets/images/fiveModule/yzy/condition.png')} alt="选考在线"/>
                </div>
                <div className='bottom'>
                    <div className='title'>志愿填报方案设计</div>
                    <img src={require('../../../assets/images/fiveModule/yzy/step.png')} alt="选考在线"/>
                </div>
            </div>
        </div>
    )
}

export default GetCareerModule;